import React from 'react';
import {
  Button, CircularProgress, Paper, Typography,
} from '@mui/material';
import useRUMView from 'common-datadog/useRUMView';
import Screen from '../Screen';
import AutopayBenefits from '../AutopayBenefits';
import Form from '../Form';
import useForm from './useForm';

const InstallmentManualPayments = ({ setupAutopay }) => {
  useRUMView('installment-manual-payments');

  const {
    form,
    handleSubmit: submitManualPayment,
    isSubmitting: isSubmittingManualPayment,
  } = useForm();

  return (
    <Screen
      header="Are you sure you want to make manual payments each month?"
      subheader={
        `With manual payments, you will have to log into our customer portal 
        to pay your loan every month. With this option you're responsible 
        for on-time payments to avoid late fees.`
      }
    >
      <Paper
        variant="outlined"
        sx={{ padding: 2, borderRadius: '16px', backgroundColor: '#FAFAFA' }}
      >
        <Typography variant="h4" textAlign="left" sx={{ mb: 2 }}>
          Benefits of enrolling in autopay.
        </Typography>
        <AutopayBenefits />
      </Paper>
      <Form form={form} onSubmit={submitManualPayment}>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={isSubmittingManualPayment}
          startIcon={isSubmittingManualPayment && <CircularProgress size={18} sx={{ color: 'info.main' }} />}
        >
          Yes, I&apos;ll Make Manual Payments
        </Button>
        <Button
          fullWidth
          variant="text"
          onClick={setupAutopay}
        >
          No, Enroll in Autopay
        </Button>
      </Form>
    </Screen>
  );
};

export default InstallmentManualPayments;
